// Copy Quote variants (e.g. a 1 night version of a 2 night package) copy their builds with
// source_build_id = the root build of the copy chain. Builds in the same link group that still
// point at the same supplier product are one supplier booking, so supplier facing views (events
// list, Suppliers tab, venue details) show one build per group. The API keeps the booking and
// itinerary fields in sync across the group; groupsizes and rates stay per quote.
//
// Grouping only covers the builds passed in, so a copy shows in its source's place when the
// source's quote isn't among them (e.g. unbooked or deactivated). Framework-agnostic so it can
// be copied as-is to ggb_client_app.

export function linkGroupKey(build) {
    return `${build.source_build_id || build.id}|${build.supplier_id}|${build.option_id}`
}

// Nights for accommodation, 0 otherwise.
function stayNights(build) {
    if (build.type_id != 1 || !build.start_date || !build.end_date) return 0
    const nights = Math.round((Date.parse(String(build.end_date).slice(0, 10)) - Date.parse(String(build.start_date).slice(0, 10))) / 86400000)
    return nights > 0 ? nights : 0
}

// The build to show for a group: the widest stay (it covers every night the others book, so its
// groupsize can hold them all), then the root itself, then the oldest copy.
function shownBuild(members) {
    return members.slice().sort((a, b) =>
        (stayNights(b) - stayNights(a))
        || ((a.source_build_id ? 1 : 0) - (b.source_build_id ? 1 : 0))
        || (a.id - b.id))[0]
}

// [{ build, linked }] in the order the shown builds appear in `builds`; `linked` holds the
// hidden others.
export function groupLinkedBuilds(builds) {
    const groups = new Map()
    builds.forEach(build => {
        const key = linkGroupKey(build)
        if (!groups.has(key)) groups.set(key, [])
        groups.get(key).push(build)
    })

    const shown = new Map()
    groups.forEach(members => {
        const build = shownBuild(members)
        shown.set(build, members.filter(b => b !== build))
    })

    return builds.filter(build => shown.has(build)).map(build => ({ build, linked: shown.get(build) }))
}

export function dedupeLinkedBuilds(builds) {
    return groupLinkedBuilds(builds).map(group => group.build)
}
